module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    green: '#65B32E',
                    gray: '#4C575D',
                    lightgreen: '#eff7e9',
                },
            },
            zIndex: {
                '-10': -10,
            },
            spacing: {
                '16/9': '56.25%',
                full: '100%',
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },
    variants: {},
    plugins: [
        require('@tailwindcss/forms'),
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/galaxy/common/*.{vue,js,scss,php}',
    ],
};
